<template>
    <article>
    <Feature :title="$t('CONTACT_PERSON')" :iconClass="'fa-database'">
        <FormRow :fieldNameArr="['']">
            <Button type="primary" @click="create" slot="b">{{ $t('ADD') }}</Button>
        </FormRow>
        <Table border :columns="schemaList" :data="contactPersons" :draggable="true" @on-drag-drop="onDrapDrop">
            <template slot-scope="{ row }" slot="modify">
                <Button type="primary" shape="circle" icon="ios-create" @click="modify(row)"></Button>
            </template>
            <template slot-scope="{ row }" slot="deleteData">
                <Button type="error" shape="circle" icon="ios-trash" @click="deleteData(row)"></Button>
            </template>
        </Table>
    </Feature>
    <Modal width="900" :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="createAndUpdateContactPerson" :title="$t('CONTACT_PERSON')"  @on-ok="confirmContactPerson">
        <FormRow :fieldNameArr="[$t('AD_ACCOUNT'), $t('PHONE'), $t('EMAIL') ,$t('REGION')] ">
            <Input v-model="contactPerson.account" slot="a" />
            <Input v-model="contactPerson.phone" slot="b" />
            <Input v-model="contactPerson.email" slot="c" />
            <Input v-model="contactPerson.region" slot="d" />
        </FormRow>
    </Modal>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: "contactPerson",
  data() {
    return {
        createAndUpdateContactPerson: false,
        contactPersons: [],
        contactPerson: {
            account: '',
            phone: '',
            email: '',
            region: ''
        },
        schemaList: [
            {
              renderHeader: (h, params) => {
                var text = this.$t('AD_ACCOUNT')
                return h('div', {
                  domProps:{
                    innerHTML:  text
                  }
                })
              },
              align: 'center',
              key: "account",
            },
            {
              renderHeader: (h, params) => {
                var text = this.$t('PHONE')
                return h('div', {
                  domProps:{
                    innerHTML:  text
                  }
                })
              },
              align: 'center',
              key: "phone",
            },
            {
                renderHeader: (h, params) => {
                    var text = this.$t('EMAIL')
                    return h('div', {
                    domProps:{
                        innerHTML:  text
                    }
                    })
                },
                align: 'center',
                key: "email",
            },
            {
                renderHeader: (h, params) => {
                    var text = this.$t('REGION')
                    return h('div', {
                    domProps:{
                        innerHTML:  text
                    }
                    })
                },
                align: 'center',
                key: "region",
            },
            {
                renderHeader: (h, params) => {
                    var text = this.$t('MODIFY')
                    return h('div', {
                        domProps:{
                            innerHTML:  text
                        }
                    })
                },
                slot: 'modify',
                align: 'center',
                width: 120,
            },
            {
                renderHeader: (h, params) => {
                    var text = this.$t('DELETE')
                    return h('div', {
                        domProps:{
                            innerHTML:  text
                        }
                    })
                },
                slot: 'deleteData',
                align: 'center',
                width: 120,
            },
        ],
    }
    },
    created() {
        this.toggleLoading(true)
        this.search()
    },
    methods: {
        ...mapGetters([
            "getModalSize"
        ]),
        ...mapActions([
            'toggleLoading'
        ]),
        deleteData(row) {
            this.toggleLoading(true)
            this.$authHttp
                .delete("contact-person/" + row.uuid)
                .then((response) => {
                    this.search()
                })
                .catch((error) => {
                })
        },
        create() {
            this.createAndUpdateContactPerson = true
        },
        modify(row) {
            this.contactPerson.account = row.account
            this.contactPerson.phone = row.phone
            this.contactPerson.email = row.email
            this.contactPerson.region = row.region
            this.contactPerson.uuid = row.uuid
            this.createAndUpdateContactPerson = true
        },
        confirmContactPerson() {
            this.toggleLoading(true)
            this.$authHttp
                .post("contact-person", JSON.stringify(this.contactPerson))
                .then((response) => {
                    this.contactPerson = {
                        account: '',
                        phone: '',
                        email: '',
                        region: ''
                    },
                    this.search()
                })
                .catch((error) => {
                })
        },
        search() {
            this.$authHttp
                .get("contact-person")
                .then((response) => {
                    this.toggleLoading(false)
                    this.contactPersons = response.data
                })
                .catch((error) => {
                })
        },
        onDrapDrop(a, b) {
            let first
            let end
            this.contactPersons.forEach(contactPerson => {
                if (contactPerson.orderIndex == Number(a) + 1) {
                    first = contactPerson.uuid
                }
                if (contactPerson.orderIndex == Number(b) + 1) {
                    end = contactPerson.uuid
                } 
            })
            this.toggleLoading(true)
            this.$authHttp
                .put("contact-person/swap/" + first+ '/' + end)
                .then((response) => {
                    this.toggleLoading(false)
                    this.contactPersons = response.data
                })
                .catch((error) => {
                })
        }
    },
    computed: {
        modalSize() {
            return this.getModalSize()
        }
    }
}
</script>

<style scoped>
</style>
